var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('HeroSection'),_c('HowItWorks'),_c('Form'),(_vm.houses)?_c('Carousel',{attrs:{"houses":_vm.houses}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }